import { render, staticRenderFns } from "./EtiquetasModalNuevo.vue?vue&type=template&id=affb97e0&scoped=true&"
import script from "./EtiquetasModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./EtiquetasModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./EtiquetasModalNuevo.vue?vue&type=style&index=0&id=affb97e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb97e0",
  null
  
)

export default component.exports